/**
 * PromptsManagementCard - Gestion des prompts
 * Extrait de Profile.js pour améliorer la maintenabilité
 * AMIRAUX UNIQUEMENT
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export const PromptsManagementCard = ({ navigate }) => (
  <Card className="relative bg-purple-950/20 backdrop-blur-xl border-purple-800/40">
    <CardHeader>
      <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-purple-400 flex items-center">
        <Sparkles className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
        Gestion des Prompts
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-slate-400 mb-4">
        Personnalisez les prompts système utilisés pour la génération d&apos;articles, d&apos;interviews et d&apos;images IA.
      </p>
      <Button
        onClick={() => navigate('/admin/prompts')}
        className="bg-purple-500/20 hover:bg-purple-500/30 text-purple-300 border border-purple-500/50 hover:border-purple-400"
        data-testid="btn-admin-prompts"
      >
        <Sparkles className="w-4 h-4 mr-2" />
        Gérer les Prompts
      </Button>
    </CardContent>
  </Card>
);

export default PromptsManagementCard;
